import React from 'react';
import styled ,{ keyframes }  from 'styled-components';

function  ValueGetter(fieldKey, promotion) {
    switch (fieldKey) {
        case 'promotion_name':
            return promotion.name || '';
        case 'start_date':
            return promotion.startDate || '';
        case 'end_date':
            return promotion.endDate || '';
        case 'description':
            return promotion.description || '';
        case 'days_of_week':
            return Array.isArray(promotion.daysOfWeek)
                ? promotion.daysOfWeek.join(', ') // Convert array to a string
                : '';
        case 'start_time':
            return promotion.startTime || '';
        case 'end_time':
            return promotion.endTime || '';
        case 'organization_name':
            return promotion.organizationName || ''; // Assuming this is added to the promotion object
        case 'discount':
            return promotion.discount ? `${promotion.discount}%` : '0%'; // Format as percentage
        default:
            return 'N/A'; // Return 'N/A' for unknown fields
    }
}
const defaultFieldSettings = [
    {
        "id": "57a4f194-9a13-4737-b37f-8d6445a9ad3b",
        "promotion_id": "ca721af6-9fc6-423a-bceb-f69ced1062be",
        "overlay_id": "63f16ab9-aae6-45ae-86ae-42177d62eecb",
        "overlay_field_id": "8f08e8ff-71f7-47f7-9b68-9874c02b9be8",
        "font_name": "Arial",
        "font_size": "medium",
        "font_color": "#00ff00",
        "alignment": "center",
        "transition": "fade",
        "transition_duration": 300,
        "transition_delay": 100,
        "position": 1,
        "visible": true,
        "created_at": "2025-01-02T12:48:43.000000Z",
        "updated_at": "2025-01-02T12:48:43.000000Z",
        "overlay_field": {
            "id": "8f08e8ff-71f7-47f7-9b68-9874c02b9be8",
            "name": "Promotion Name",
            "key": "promotion_name",
            "created_at": "2025-01-02T12:29:23.000000Z",
            "updated_at": "2025-01-02T12:29:23.000000Z"
        }
    },
    {
        "id": "99ce7e9a-c21b-49fc-ab1b-5b2102f8c092",
        "promotion_id": "ca721af6-9fc6-423a-bceb-f69ced1062be",
        "overlay_id": "63f16ab9-aae6-45ae-86ae-42177d62eecb",
        "overlay_field_id": "a1090cdc-bf31-4899-962e-1f3d3491769f",
        "font_name": "Arial",
        "font_size": "medium",
        "font_color": "#00ff00",
        "alignment": "center",
        "transition": "fade",
        "transition_duration": 300,
        "transition_delay": 100,
        "position": 2,
        "visible": true,
        "created_at": "2025-01-02T12:48:43.000000Z",
        "updated_at": "2025-01-02T12:48:43.000000Z",
        "overlay_field": {
            "id": "a1090cdc-bf31-4899-962e-1f3d3491769f",
            "name": "Start Date",
            "key": "start_date",
            "created_at": "2025-01-02T12:29:23.000000Z",
            "updated_at": "2025-01-02T12:29:23.000000Z"
        }
    },
    {
        "id": "dc5b3b68-5546-4e1b-ab6a-9e52bdcf0e1e",
        "promotion_id": "ca721af6-9fc6-423a-bceb-f69ced1062be",
        "overlay_id": "63f16ab9-aae6-45ae-86ae-42177d62eecb",
        "overlay_field_id": "9b2227c6-ba6d-41e0-ac83-52d7a6197521",
        "font_name": "Arial",
        "font_size": "medium",
        "font_color": "#00ff00",
        "alignment": "center",
        "transition": "fade",
        "transition_duration": 300,
        "transition_delay": 100,
        "position": 3,
        "visible": true,
        "created_at": "2025-01-02T12:48:43.000000Z",
        "updated_at": "2025-01-02T12:48:43.000000Z",
        "overlay_field": {
            "id": "9b2227c6-ba6d-41e0-ac83-52d7a6197521",
            "name": "End Date",
            "key": "end_date",
            "created_at": "2025-01-02T12:29:23.000000Z",
            "updated_at": "2025-01-02T12:29:23.000000Z"
        }
    },
    {
        "id": "28585b37-a55a-4fe1-ab5e-2f73014fe6f6",
        "promotion_id": "ca721af6-9fc6-423a-bceb-f69ced1062be",
        "overlay_id": "63f16ab9-aae6-45ae-86ae-42177d62eecb",
        "overlay_field_id": "a31ca70e-8e1d-4238-81a0-e9bcfadf3f81",
        "font_name": "Arial",
        "font_size": "medium",
        "font_color": "#00ff00",
        "alignment": "center",
        "transition": "fade",
        "transition_duration": 300,
        "transition_delay": 100,
        "position": 4,
        "visible": true,
        "created_at": "2025-01-02T12:48:43.000000Z",
        "updated_at": "2025-01-02T12:48:43.000000Z",
        "overlay_field": {
            "id": "a31ca70e-8e1d-4238-81a0-e9bcfadf3f81",
            "name": "Description",
            "key": "description",
            "created_at": "2025-01-02T12:29:23.000000Z",
            "updated_at": "2025-01-02T12:29:23.000000Z"
        }
    },
    {
        "id": "8782fb6b-7ada-4996-8d80-9c0860d74b3b",
        "promotion_id": "ca721af6-9fc6-423a-bceb-f69ced1062be",
        "overlay_id": "63f16ab9-aae6-45ae-86ae-42177d62eecb",
        "overlay_field_id": "667f1316-dc62-4fe7-bf77-2b4f4544317a",
        "font_name": "Arial",
        "font_size": "medium",
        "font_color": "#00ff00",
        "alignment": "center",
        "transition": "fade",
        "transition_duration": 300,
        "transition_delay": 100,
        "position": 5,
        "visible": true,
        "created_at": "2025-01-02T12:48:43.000000Z",
        "updated_at": "2025-01-02T12:48:43.000000Z",
        "overlay_field": {
            "id": "667f1316-dc62-4fe7-bf77-2b4f4544317a",
            "name": "Days of Week",
            "key": "days_of_week",
            "created_at": "2025-01-02T12:29:23.000000Z",
            "updated_at": "2025-01-02T12:29:23.000000Z"
        }
    },
    {
        "id": "08e8b6a9-a1b7-4e21-8f80-10e768a7cfa2",
        "promotion_id": "ca721af6-9fc6-423a-bceb-f69ced1062be",
        "overlay_id": "63f16ab9-aae6-45ae-86ae-42177d62eecb",
        "overlay_field_id": "4d147bb7-0da9-4a57-8aae-b786d8cf605e",
        "font_name": "Arial",
        "font_size": "medium",
        "font_color": "#00ff00",
        "alignment": "center",
        "transition": "fade",
        "transition_duration": 300,
        "transition_delay": 100,
        "position": 6,
        "visible": true,
        "created_at": "2025-01-02T12:48:43.000000Z",
        "updated_at": "2025-01-02T12:48:43.000000Z",
        "overlay_field": {
            "id": "4d147bb7-0da9-4a57-8aae-b786d8cf605e",
            "name": "Start Time",
            "key": "start_time",
            "created_at": "2025-01-02T12:29:23.000000Z",
            "updated_at": "2025-01-02T12:29:23.000000Z"
        }
    },
    {
        "id": "40e8b33d-37ee-4c14-a203-93be893aa433",
        "promotion_id": "ca721af6-9fc6-423a-bceb-f69ced1062be",
        "overlay_id": "63f16ab9-aae6-45ae-86ae-42177d62eecb",
        "overlay_field_id": "46c0ebeb-0058-49a0-8925-f9dfa3963870",
        "font_name": "Arial",
        "font_size": "medium",
        "font_color": "#00ff00",
        "alignment": "center",
        "transition": "fade",
        "transition_duration": 300,
        "transition_delay": 100,
        "position": 7,
        "visible": true,
        "created_at": "2025-01-02T12:48:43.000000Z",
        "updated_at": "2025-01-02T12:48:43.000000Z",
        "overlay_field": {
            "id": "46c0ebeb-0058-49a0-8925-f9dfa3963870",
            "name": "End Time",
            "key": "end_time",
            "created_at": "2025-01-02T12:29:23.000000Z",
            "updated_at": "2025-01-02T12:29:23.000000Z"
        }
    },
    {
        "id": "516b1559-8ee2-4658-b30a-51ea9cfaa610",
        "promotion_id": "ca721af6-9fc6-423a-bceb-f69ced1062be",
        "overlay_id": "63f16ab9-aae6-45ae-86ae-42177d62eecb",
        "overlay_field_id": "4b004b10-11a8-4cb2-ac23-e5bcaa5cc19f",
        "font_name": "Arial",
        "font_size": "medium",
        "font_color": "#00ff00",
        "alignment": "center",
        "transition": "fade",
        "transition_duration": 300,
        "transition_delay": 100,
        "position": 8,
        "visible": true,
        "created_at": "2025-01-02T12:48:43.000000Z",
        "updated_at": "2025-01-02T12:48:43.000000Z",
        "overlay_field": {
            "id": "4b004b10-11a8-4cb2-ac23-e5bcaa5cc19f",
            "name": "Organization Name",
            "key": "organization_name",
            "created_at": "2025-01-02T12:29:23.000000Z",
            "updated_at": "2025-01-02T12:29:23.000000Z"
        }
    },
    {
        "id": "9fab2148-f956-460f-9e53-09899c5429b8",
        "promotion_id": "ca721af6-9fc6-423a-bceb-f69ced1062be",
        "overlay_id": "63f16ab9-aae6-45ae-86ae-42177d62eecb",
        "overlay_field_id": "5b77416b-b04f-4e1e-bead-dde0176aee58",
        "font_name": "Arial",
        "font_size": "medium",
        "font_color": "#00ff00",
        "alignment": "center",
        "transition": "fade",
        "transition_duration": 300,
        "transition_delay": 100,
        "position": 9,
        "visible": true,
        "created_at": "2025-01-02T12:48:43.000000Z",
        "updated_at": "2025-01-02T12:48:43.000000Z",
        "overlay_field": {
            "id": "5b77416b-b04f-4e1e-bead-dde0176aee58",
            "name": "Discount",
            "key": "discount",
            "created_at": "2025-01-02T12:29:23.000000Z",
            "updated_at": "2025-01-02T12:29:23.000000Z"
        }
    },
    {
        "id": "562af3aa-9b0e-4546-add1-58e56f312bab",
        "promotion_id": "ca721af6-9fc6-423a-bceb-f69ced1062be",
        "overlay_id": "63f16ab9-aae6-45ae-86ae-42177d62eecb",
        "overlay_field_id": "5ca9e8c0-dfd8-43ee-8e9f-97da5fc95ef8",
        "font_name": "Arial",
        "font_size": "medium",
        "font_color": "#00ff00",
        "alignment": "center",
        "transition": "fade",
        "transition_duration": 300,
        "transition_delay": 100,
        "position": 10,
        "visible": true,
        "created_at": "2025-01-02T12:48:43.000000Z",
        "updated_at": "2025-01-02T12:48:43.000000Z",
        "overlay_field": {
            "id": "5ca9e8c0-dfd8-43ee-8e9f-97da5fc95ef8",
            "name": "Campaign Start Date",
            "key": "campaign_start_date",
            "created_at": "2025-01-02T12:29:23.000000Z",
            "updated_at": "2025-01-02T12:29:23.000000Z"
        }
    },
    {
        "id": "90c10b90-4c5c-49f4-9810-b09d61018984",
        "promotion_id": "ca721af6-9fc6-423a-bceb-f69ced1062be",
        "overlay_id": "63f16ab9-aae6-45ae-86ae-42177d62eecb",
        "overlay_field_id": "8f95e381-ac25-4df8-a989-5afff514ee95",
        "font_name": "Arial",
        "font_size": "medium",
        "font_color": "#00ff00",
        "alignment": "center",
        "transition": "fade",
        "transition_duration": 300,
        "transition_delay": 100,
        "position": 11,
        "visible": true,
        "created_at": "2025-01-02T12:48:43.000000Z",
        "updated_at": "2025-01-02T12:48:43.000000Z",
        "overlay_field": {
            "id": "8f95e381-ac25-4df8-a989-5afff514ee95",
            "name": "Campaign End Date",
            "key": "campaign_end_date",
            "created_at": "2025-01-02T12:29:23.000000Z",
            "updated_at": "2025-01-02T12:29:23.000000Z"
        }
    }
];

class PromotionOverlay {

    constructor(data = {}) {
        this.id = data?.id || null;
        this.overlayId = data?.overlayId || data?.overlay_id || data?.overlay?.id || null;
        this.name = data?.name || data?.overlay?.name || '';
        this.backgroundImage =
            data?.backgroundImage || data?.overlay?.background_image || data?.background_image || '';
        const incomingFieldSettings = data?.field_settings ?? data?.fieldSettings ?? null;

        this.fieldSettings = (incomingFieldSettings
            ? incomingFieldSettings
            : defaultFieldSettings
        ).map((setting) => ({
            ...setting,
            overlay_field:
                setting.overlay_field || setting.overlayField || setting.overlay_field || null,
        }));
    }

    toBackendFormat() {
        return {
            id: this.id,
            overlay_id: this.overlayId,
            name: this.name,
            background_image: this.backgroundImage,
            field_settings: this.fieldSettings, // Adjust if field settings require formatting
        };
    }

    render(promotion, scale = 1) {
        const IframeContainer = styled.div`
            width: 100%;
            aspect-ratio: 16 / 9;
            border: 1px solid #ccc;
            overflow: hidden;
            background: #f9f9f9;
            position: relative;
            border-radius: 12px;
        `;

        const Iframe = styled.div`
            width: 100%;
            height: 100%;
            background-image: url(${this.backgroundImage});
            background-size: cover;
            background-position: center;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: start;
        `;

        const FieldRow = styled.div`
        width: 90%;
        color: ${(props) => props.fontColor || '#000'};
        font-family: ${(props) => props.fontFamily || 'Arial'};
        font-size: ${(props) => {
            const base =
                props.fontSize === 'small'
                    ? 1.6
                    : props.fontSize === 'medium'
                    ? 1.9
                    : 2.2;
            return `${base * (props.scale || 1)}rem`;
        }};
        text-align: ${(props) => props.textAlign || 'center'};
        background-color: transparent;
            position: absolute;
            top: ${(props) => props.top || 0}%;
    `;

        return (
            <IframeContainer>
                <Iframe>
                    {this.fieldSettings
                        .filter((field) => field.visible)
                        .map((field) => {
                            const value = ValueGetter(field.overlay_field.key, promotion); // Get value dynamically
                            return (
                                <FieldRow
                                    key={field.overlay_field.id}
                                    fontColor={field.font_color}
                                    fontFamily={field.font_name}
                                    fontSize={field.font_size}
                                    textAlign={field.alignment}
                                    top={field.position}
                                    scale={scale}
                                >
                                    {value}
                                </FieldRow>
                            );
                        })}
                </Iframe>
            </IframeContainer>
        );
    }
    renderAnimated(promotion, scale = 1) {
        const fadeIn = keyframes`
            from {
                opacity: 0;
            }
            to {
                opacity: 1;
            }
        `;

        const slideIn = keyframes`
            from {
                transform: translateX(-100%);
                opacity: 0;
            }
            to {
                transform: translateX(0);
                opacity: 1;
            }
        `;

        const zoomIn = keyframes`
            from {
                transform: scale(0.8);
                opacity: 0;
            }
            to {
                transform: scale(1);
                opacity: 1;
            }
        `;

        const getKeyframes = (transition) => {
            switch (transition) {
                case 'fade':
                    return fadeIn;
                case 'slide':
                    return slideIn;
                case 'zoom':
                    return zoomIn;
                default:
                    return fadeIn; // Default fallback
            }
        };

        const IframeContainer = styled.div`
            width: 100%;
            aspect-ratio: 16 / 9;
            border: 1px solid #ccc;
            overflow: hidden;
            background: #f9f9f9;
            position: relative;
            border-radius: 12px;
        `;

        const Iframe = styled.div`
            width: 100%;
            height: 100%;
            background-image: url(${this.backgroundImage});
            background-size: cover;
            background-position: center;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: start;
        `;

        const FieldRow = styled.div`
            width: 90%;
            color: ${(props) => props.fontColor || '#000'};
            font-family: ${(props) => props.fontFamily || 'Arial'};
            font-size: ${(props) => {
            const base =
                props.fontSize === 'small'
                    ? 1.6
                    : props.fontSize === 'medium'
                    ? 1.9
                    : 2.2;
            return `${base * (props.scale || 1)}rem`;
        }};
            text-align: ${(props) => props.textAlign || 'center'};
            background-color: transparent;
            position: absolute;
            top: ${(props) => props.top || 0}%;
            animation: ${(props) => getKeyframes(props.transition)} ${(props) => props.duration || 1}s ease-in-out;
            animation-delay: ${(props) => props.delay || 0}s;
            opacity: 0; /* Initial state for animation */
            animation-fill-mode: forwards; /* Keep final state after animation */
        `;

        return (
            <IframeContainer>
                <Iframe>
                    {this.fieldSettings
                        .filter((field) => field.visible)
                        .map((field) => {
                            const value = ValueGetter(field.overlay_field.key, promotion);
                            return (
                                <FieldRow
                                    key={field.overlay_field.id}
                                    fontColor={field.font_color}
                                    fontFamily={field.font_name}
                                    fontSize={field.font_size}
                                    textAlign={field.alignment}
                                    top={field.position}
                                    scale={scale}
                                    duration={field.transition_duration / 1000} // Convert ms to seconds
                                    delay={field.transition_delay / 1000} // Convert ms to seconds
                                    transition={field.transition} // Pass the transition type
                                >
                                    {value}
                                </FieldRow>
                            );
                        })}
                </Iframe>
            </IframeContainer>
        );
    }
}

export default PromotionOverlay;
